import React, {Component} from 'react';
import EditableTable from "@components/Table/EditableTable";
import moment from "moment";
import _ from "lodash";
import actions from "@redux/equipmentCategory/actions";
import {connect} from "react-redux";
import {api} from "@redux/api";
import { useAuth, AUTH_LEVEL } from '@/hooks/use-auth';
import { useSmartNavigate } from '@/hooks/use-smart-navigate';
import {
    Equipment_CategoryColumns,
    Equipment_CategoryProps
} from "@containers/facility/Equipment_Category/Equipment_CategoryColumns";
import {
    Equipment_CategoryFormFields,
    Equipment_CategoryRelated
} from "@containers/facility/Equipment_Category/Equipment_CategoryFormFields";

const EQUIPMENT_CATEGORY_MOBILE_EXCLUDE_KEYS = [
    "name",
    "life_expectancy",
    "modified_date",
];

const EQUIPMENT_CATEGORY_MOBILE_INCLUDE_KEYS = [
    "comment",
];

const formatEquipmentCategoryDate = (value) => {
    const date = moment(value);
    return value && date.isValid() ? date.format("YYYY-MM-DD HH:mm") : "-";
};

const renderEquipmentCategoryMobileHeader = (record, navigateToDetail) => (
    <div className="equipment-category-mobile-card">
        <div className="equipment-category-mobile-card-main">
            <span
                className="equipment-category-mobile-card-title"
                title={record.name || ""}
                onClick={(event) => {
                    event.stopPropagation();
                    navigateToDetail(record.id);
                }}
            >
                {record.name || "-"}
            </span>
            <span className="equipment-category-mobile-card-date">
                {formatEquipmentCategoryDate(record.modified_date)}
            </span>
        </div>
        <div className="equipment-category-mobile-card-meta">
            <span className="equipment-category-mobile-card-label">Life Expectancy</span>
            <span className="equipment-category-mobile-card-value">
                {record.life_expectancy ?? "-"}
                {record.life_expectancy != null && record.life_expectancy !== "" ? " years" : ""}
            </span>
        </div>
    </div>
);

class Equipment_Category extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading: false,
        }
    }

    handleCreateEquipmentCategory = (body) => {
        return api.createEquipmentCategory(body).then(
            response => {
                console.log('create', response);
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleDeleteEquipmentCategory = (id) => {
        return api.deleteEquipmentCategory(id).then(
            response => {
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleBulkInsert = (body) => {
        return api.bulkEquipmentCategoryInsert(body).then(
            response => {
                return response.data
            }
        ).catch(error => {
            return (
                error
            )
        });
    }

    handleBulkDelete = (body) => {
        return api.bulkDeleteEquipmentCategory(body).then(
            response => {
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handOnlineSave = (key, row) => {
        return api.editEquipmentCategory(key, row).then(
            response => {

                return response
            }
        ).catch(error => (
            error
        ));
    }


    handleFilter = (query) => {
        console.log('triggered', query)
        this.setState({
            isLoading: true
        })
        return api.filterEquipmentCategory(query).then(
            response => {
                let dataSource = response.data.results
                return {
                    data: dataSource,
                    success: true,
                }
            }
        ).catch(error => (
            error
        ));
    }

    getEquipmentCategory = (data) => {
        this.setState({
            data,
            isLoading: false,
        })
        this.props.setEquipmentCategorySuccess(data)
    }

    onNew = () => {
        this.props.navigateAndCloseTabs(
            "/admin/create-equipment-category",
            "/admin/create-equipment-category"
        );
    }

    render() {
        return (

            <div className="m-5">
                <EditableTable
                    columns={Equipment_CategoryColumns}
                    data={this.state.data}
                    columnProps={Equipment_CategoryProps}
                    formFields={Equipment_CategoryFormFields}
                    formRelated={Equipment_CategoryRelated}
                    getRecord={this.getEquipmentCategory}
                    createRecords={this.handleCreateEquipmentCategory}
                    deleteRecord={this.handleDeleteEquipmentCategory}
                    bulkInsert={this.handleBulkInsert}
                    bulkDelete={this.handleBulkDelete}
                    handOnlineSave={this.handOnlineSave}
                    handleFilter={this.handleFilter}
                    relatedList={this.props.relatedList}
                    hide_date={true}
                    hide_imports={true}
                    isRowClickable={false}
                    hide_search={true}
                    isChat={false}
                    isRelated={false}
                    isAttachments={false}
                    hid_new={!this.props.canWrite}
                    onNew={this.onNew}
                    canDelete={this.props.canFullAccess}
                    mobileCardHeaderRender={(record) => renderEquipmentCategoryMobileHeader(
                        record,
                        (id) => this.props.navigateAndCloseTabs(
                            `/admin/equipment-category-detail/${id}`,
                            "/admin/equipment-category-detail/"
                        )
                    )}
                    mobileExpandedExcludeKeys={EQUIPMENT_CATEGORY_MOBILE_EXCLUDE_KEYS}
                    mobileExpandedIncludeKeys={EQUIPMENT_CATEGORY_MOBILE_INCLUDE_KEYS}
                    onDoubleClick={(record) => {
                        this.props.navigateAndCloseTabs(`/admin/equipment-category-detail/${record.id}`, '/admin/equipment-category-detail/');
                    }}
                />
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        Facility: _.get(state.Facility, 'data'),
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setEquipmentCategorySuccess: (e) => dispatch(actions.EquipmentCategorySuccess(e)),
    }
}

const withHooks = (Component) => {
    const NewComponent = (props) => {
        const canWrite = useAuth('equipmentCategory', AUTH_LEVEL.WRITE);
        const canFullAccess = useAuth('equipmentCategory', AUTH_LEVEL.FULL_ACCESS);
        const { navigateAndCloseTabs } = useSmartNavigate();
        return <Component {...props} canWrite={canWrite} canFullAccess={canFullAccess} navigateAndCloseTabs={navigateAndCloseTabs} />
    }
    return NewComponent;
}

export default withHooks(connect(
    mapStateToProps,
    mapDispatchToProps
)(Equipment_Category));
